<script setup>
import AristLogo from '@/components/shared/core/AristLogo.vue'
</script>

<template>
  <footer :class="$style.footer">
    <span :class="$style.caption">
      Secure training powered by
    </span>
    <div :class="$style.logoWrapper">
      <a
        href="https://arist.com"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Arist"
      >
        <AristLogo :class="$style.aristLogo" />
      </a>
    </div>
  </footer>
</template>

<style module>
.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.caption {
  font-size: var(--font-size-text-normal);
  line-height: var(--line-height-text);
  color: var(--color-text-muted);
  letter-spacing: -0.006em;
}
.logoWrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.aristLogo {
  display: block;
  max-width: 100%;
  object-fit: contain;
  height: 1.5rem;
}
</style>
